import { Vue, Component, Prop, Watch, Inject } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import uuid4 from 'uuid';
import moment from 'moment';
import style from './style.vue';
import { EmpServiceAPIActions } from '@/services/empService';
import baseAPIService from '@/services/base/baseAPIService';
import AddHotDialog from '@/views/components/shopAdvertisement/addhotDialog';
import { noop, getConditionText, setCondition } from '@/util';
import { defaultImg } from '@/views/components/newDisplayConfig/shop';
import LinkForm from '@/views/components/linkForm/linkForm.vue';
import { Functions } from '@/library/utils/functions';
import { globalElement } from '@/library/utils/globalElement';

@Component({
  mixins: [style],
})
export default class AdContentItem extends Vue {
  @Prop()
  value: SiteAdConfig[];

  @Inject()
  openCoupon: Function;

  @Prop()
  index;

  @Prop({ default: 300 })
  pSize: number;

  @Prop({ default: () => [] })
  attrButeList: ItemArray;

  @Prop()
  fromPage: number;

  imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  data: SiteAdConfig = null;

  siteId = 0;
  uuid = uuid4();
  hositoryData: SiteAdConfig = null;
  condition = {
    id: '',
    text: '',
  };
  receiptConfig = {
    type: 0,
    id: '',
  };

  @Prop({ default: false })
  classAd: boolean;

  @Watch('value', { immediate: true, deep: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  async created() {
    this.siteId = +globalElement.Vm.$route.params.siteId;
    this.hositoryData = Object.assign(cloneDeep(this.data), {
      advLinkVal1: cloneDeep([this.data.advLinkType === 1 ? this.data.linkList[0] : {}]),
      advLinkVal2: cloneDeep(this.data.advLinkType === 1 ? [] : this.data.linkList),
    });
    this.receiptConfig = { ...this.receiptConfig, ...cloneDeep(this.data?.receiptConfig) };
    // @ts-expect-error
    this.condition.text = await getConditionText(this.receiptConfig.id, this.siteId);
    this.condition.id = this.receiptConfig.id;
  }

  /**
   * 根据筛选条件
   */
  async setCondition(e) {
    const params = {
      siteId: this.siteId, sgId: globalElement.Vm.$route.params.sgId, id: this.condition.id,
    };
    e.stopPropagation();
    const r: any = await setCondition(params);
    this.condition = r;
    this.receiptConfig.id = r.id;
    this.data = { ...this.data, receiptConfig: this.receiptConfig };
    this.$emit('input', this.data);
  }

  beforeUpload(file) {
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    const isGIF = file.type === 'image/gif';
    const isLt1000KB = file.size / 1024 < 1024;

    if (!isJPG && !isPNG && !isGIF) {
      this.$message.error('上传图片只支持 JPG/JPEG/PNG/GIF 格式!');
    }
    if (!isLt1000KB) {
      this.$message.error(`上传图片大小不能超过 ${1}M!`);
    }

    return (isJPG || isPNG || isGIF) && isLt1000KB;
  }

  uploadSuccess(res: HttpAPIRetItem<any>) {
    this.getImgInfo(res).then((img: any) => {
      this.data.advPic = res.content;
      this.data.width = img.width;
      this.data.height = img.height;
    });
  }

  getImgInfo(info) {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = info.content;
      const arr = { width: 0, height: 0 };
      img.onload = function() {
        arr.width = img.width;
        arr.height = img.height;
        resolve(arr);
      };
    });
  }

  // 添加热区广告
  addHotAd(i) {
    if (!this.data.advPic) {
      this.$message.warning('请先上传图片');
      return;
    }
    AddHotDialog.open({
      img: this.data.advPic,
      hotList: this.data.linkList,
      state: 1,
      form: { siteCodes: [this.$route.params.code], advId: 0 },
      openCoupon: this.openCoupon(),
      empCode: this.$store.state.empCode,
      siteId: this.siteId,
      mode: 2,
      // goodsClassList: this.goodsClassList(),
      attributeList: this.attrButeList,
    }).then((result) => {
      this.data.linkList = result;
      (this.hositoryData as any).advLinkVal2 = cloneDeep(result);
    }, noop);
  }

  handleDel(i) {
    this.$emit('delete', this.index);
  }

  clearCondition() {
    this.condition = { id: '', text: '' };
    this.receiptConfig.id = '';
    this.data = { ...this.data, receiptConfig: this.receiptConfig };
    this.$emit('input', this.data);
  }

  onLinkChange(val) {
    (this.hositoryData as any).advLinkVal1 = cloneDeep([val]);
    this.data.linkList[0] ? (this.data.linkList[0] = val) : this.data.linkList.push(val);
    this.data.linkList.map((i) => {
      delete i.hotPosition;
      return i;
    });
  }

  linkTypeChange(val) {
    this.data.linkList = cloneDeep((this.hositoryData as any)[`advLinkVal${val}`]);
  }

  validateDate() {
    let startTime = '';
    let endTime = '';
    let curTime = '';
    const newTime = new Date();
    if (this.data.endOfTime && this.data.startOfTime) {
      startTime = this.data.startOfTime.valueOf();
      curTime = moment(newTime).format('YYYY-MM-DD HH:mm:ss');
      endTime = this.data.endOfTime.valueOf();
      if (endTime < startTime) {
        this.$message.error('有效期结束时间不能小于开始时间！');
        this.data.endOfTime = '';
        return;
      }
      if (endTime < curTime) {
        this.$message.error('有效期结束时间不能小于当前时刻！');
        this.data.endOfTime = '';
        return;
      }
      if (endTime === curTime) {
        this.$message.error('有效期结束时间不能为当前时刻！');
        this.data.endOfTime = '';
        return;
      }
    }
  }

  validateBegin() {
    let startTime = '';
    let endTime = '';
    if (this.data.startOfTime && this.data.endOfTime) {
      startTime = this.data.startOfTime.valueOf();
      endTime = this.data.endOfTime.valueOf();
      if (endTime < startTime) {
        this.$message.error('有效期开始时间不能大于结束时间！');
        this.data.startOfTime = '';
        return;
      }
    }
  }

  clickCheckbox() {
    this.data = { ...this.data, receiptConfig: this.receiptConfig };
    this.$emit('input', this.data);
  }

  get excludeContent() {
    return this.openCoupon() ? this.classAd ? [7, 8, 14, 15, 16, 22] : [7, 8, 14, 15, 16] : this.classAd ? [7, 8, 12, 14, 15, 16, 22] : [7, 8, 12, 14, 15, 16];
  }

  render(h) {
    return (
      <div class="ad-content-item">
        <i class="el-icon-error delete" onClick={this.handleDel.bind(this)} />
        <div class="ad-content">
          <el-form-item class="ad-content-img">
            <img src={this.data.advPic || defaultImg} class="img" />
            <el-upload
              action={this.imgTpConfig}
              headers={this.tokenData}
              before-upload={this.beforeUpload}
              maxSize={1024}
              data={{ corpId: baseAPIService.resolveCorpId() }}
              {...{
                props: {
                  'on-success': val => this.uploadSuccess(val),
                  'on-error': () => {
                    this.$message.error('图片上传错误，请稍后重试！');
                  },
                },
              }}
              show-file-list={false}
            >
              <span class="modify">修改</span>
            </el-upload>
          </el-form-item>
          <el-form-item class="ad-title" label="标题">
            <el-input v-model={this.data.advTitle} placeholder="建议20字以内，选填" maxlength={20} clearable />
          </el-form-item>
          {this.classAd && (
            <el-form-item class="add-link">
              <LinkForm
                value={this.data.linkList[0]}
                onInput={val => (this.data.linkList[0] = val)}
                empCode={+globalElement.Vm.$store.state.empCode}
                state={1}
                sgId={+globalElement.Vm.$route.params.sgId}
                siteCodes={[globalElement.Vm.$route.params.code]}
                onChange={val => this.onLinkChange(val)}
                linkText="链接"
                ref="linkForm"
                // goodsClassList={this.goodsClassList()}
                mode={2}
                sortShow={true}
                dialogFooter={false}
                siteId={this.siteId}
                exclude={this.excludeContent}
                attributeList={this.attrButeList}
                indexIcon={this.index}
                fromPage={this.fromPage}
                class="hot-ad-link1"
              />
            </el-form-item>
          )}
          {!this.classAd && (
            <el-form-item class="add-link">
              <el-radio-group v-model={this.data.advLinkType} onChange={val => this.linkTypeChange(val)}>
                <div>
                  <el-radio label={1} class="line-height-28">
                    链接
                  </el-radio>
                </div>
                <div>
                  <el-radio label={2} class="line-height-28">
                    热区
                  </el-radio>
                </div>
              </el-radio-group>
              {this.data.advLinkType === 1 && (
                <LinkForm
                  value={this.data.linkList[0]}
                  onInput={val => (this.data.linkList[0] = val)}
                  empCode={+globalElement.Vm.$store.state.empCode}
                  state={1}
                  sgId={+globalElement.Vm.$route.params.sgId}
                  siteCodes={[globalElement.Vm.$route.params.code]}
                  onChange={val => this.onLinkChange(val)}
                  linkText=""
                  ref="linkForm"
                  sortShow={true}
                  dialogFooter={false}
                  // goodsClassList={this.goodsClassList()}
                  mode={2}
                  siteId={this.siteId}
                  exclude={this.excludeContent}
                  attributeList={this.attrButeList}
                  indexIcon={this.index}
                  fromPage={this.fromPage}
                  class="hot-ad-link"
                />
              )}
              {this.data.advLinkType === 2 && (
                <div>
                  <div class="scopeSpan line-height-28 font-size-12 r-ml-0" onClick={this.addHotAd.bind(this)}>
                    设置热区
                  </div>
                  <div class="hotarea">
                    已设置&nbsp;<span class="font-bold">{this.data.linkList.length}</span>&nbsp;个热区
                  </div>
                </div>
              )}
            </el-form-item>
          )}
          {!this.classAd && (
            <el-form-item label="有效期" class="datepicker">
              <el-date-picker v-model={this.data.startOfTime} onChange={this.validateBegin.bind(this)}
                              value-format={'yyyy-MM-dd HH:mm:ss'} type="datetime" placeholder="开始时间"
              />
              <span class="font-size-12 r-ml-8">至</span>
              <el-date-picker v-model={this.data.endOfTime} onChange={this.validateDate.bind(this)}
                              value-format={'yyyy-MM-dd HH:mm:ss'} type="datetime" placeholder="结束时间"
              />
            </el-form-item>
          )}
          {!this.classAd && (
            <el-form-item lebel="" class="condition">
              <el-checkbox class="condition-checkbox" v-model={this.receiptConfig.type}
                           onChange={() => this.clickCheckbox()} true-label={1} false-label={0} label="开启部分会员可见"
              />
              {this.receiptConfig.type
                ? <div class="condition-selected row items-center" onClick={e => this.setCondition(e)}>
                  {this.condition.text ? (
                    <el-tag class="tag" closable onClose={() => {
                      this.clearCondition();
                    }}
                    >
                      {this.condition.text}
                    </el-tag>
                  ) : (
                    <span class="placeholder">
                      请设置顾客参与门槛
                    </span>
                  )}
                  <i class="iconfont iconshaixuan1" />
                </div> : ''}
            </el-form-item>
          )}
        </div>
      </div>
    );
  }
}
